const create = async (blob: Blob): Promise<string> => {
  const formData = new FormData()
  formData.append('audio', blob, 'recording.webm')

  const response = await fetch('/api/transcriptions', {
    method: 'POST',
    credentials: 'include',
    body: formData,
  })

  if (!response.ok) {
    throw new Error(`Transcription failed: ${response.status}`)
  }

  const data = (await response.json()) as { text: string }
  return data.text
}

export default { create }
